import { Component, Injector, Input, Optional } from '@angular/core';

import { OproepHistorieService } from 'src/app/core/service/oproep-historie.service';
import { OproepHistorie } from 'src/app/core/dto/oproep-historie';
import { Filter, PagedCollectionComponent, ColumnDefinition, createColumnDefinitions, SearchableType } from '@mango/core';
import { Instrument } from 'src/app/core/dto/instrument';

@Component({
    selector: 'c-i-j-borculo-oproep-historie-collection',
    templateUrl: './oproep-historie-collection.component.html'/*,
    styleUrls: ['./oproep-historie-collection.component.css'] */
})
export class OproepHistorieCollectionComponent extends PagedCollectionComponent<OproepHistorie> {
    columnDefinitions: ColumnDefinition[] = createColumnDefinitions<OproepHistorie>([
		{ colDef: 'naam', prop: x => x.naam, searchable: SearchableType.String },        
		{ colDef: 'datumKalibratie', prop: x => x.datumKalibratie, searchable: SearchableType.Date },
		{ colDef: 'datumOproep', prop: x => x.datumOproep, searchable: SearchableType.Date },
        { colDef: 'datumMail', prop: x => x.datumMail, searchable: SearchableType.Date }
    ]);
    displayedColumns = this.columnDefinitions.map(x => x.colDef);

    constructor(public service: OproepHistorieService, @Optional() protected filter: Filter<OproepHistorie>, injector: Injector) {
        super('/oproepHistorie/oproepHistorie', injector, OproepHistorie);

        this.initInput('instrument', this.filterBuilder.equal(x => x.instrument.id));

        this.filter.onGetChipLabel(x => x.naam, () => 'Naam');
        this.filter.onGetChipLabel(x => x.datumKalibratie, () => 'Datum kalibratie');
        this.filter.onGetChipLabel(x => x.datumOproep, () => 'Datum oproep');
        this.filter.onGetChipLabel(x => x.datumMail, () => 'Datum mail');
    }

    canDelete() {
        return false;
    }

    @Input() set instrument(val: Instrument) {
        this.handleInput('instrument', val.id);
    }
}